module.exports = __webpack_public_path__ + "img/OPI-Banner-02.26a31e3c.jpg";